module.exports = __webpack_public_path__ + "1756b4420dd2d3217b6cfe02059b010b.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
 ** module id = 2015
 ** module chunks = 73
 **/